export enum WatermarksPositions {
  RIGHT_TOP = 'rightTop',
  RIGHT_BOTTOM = 'rightBottom',
  LEFT_TOP = 'leftTop',
  LEFT_BOTTOM = 'leftBottom',
  LEFT_FULL = 'leftFullWidth',
  RIGHT_FULL = 'rightFullWidth',
}
